{
  "common": {
    "id": "common",
    "__comment": "This is a special type of data source that cannot be selected on its own but provides common values that other data sources inherit from.",
    "segments": {
      "magic-carpet": { "average": 2, "potential": 3 }
    }
  },
  "giz": {
    "id": "giz",
    "source_title": "Passenger capacity of different transport modes",
    "source_author": "Transformative Urban Mobility Initiative (TUMI)",
    "source_url": "https://www.transformative-mobility.org/publications/passenger-capacity-of-different-transport-modes",
    "typical_lane_width": 3.5,
    "typical_lane_width_ft": 11.5,
    "segments": {
      "sidewalk": { "average": 15000, "potential": 15000 },
      "drive-lane": {
        "average": 1500,
        "potential": 2000,
        "variants": {
          "car-type:pedestrian": {
            "inherits": "sidewalk"
          }
        }
      },
      "bike-lane": {
        "average": 12000,
        "potential": 12000,
        "variants": {
          "bike-direction:twoway-left": {
            "average": 24000,
            "potential": 24000
          },
          "bike-direction:twoway-right": {
            "average": 24000,
            "potential": 24000
          }
        }
      },
      "scooter": { "inherits": "bike-lane" },
      "light-rail": { "average": 18000, "potential": 20000 },
      "streetcar": { "inherits": "light-rail" },
      "bus-lane": { "average": 5000, "potential": 8000 },
      "brt-lane": { "average": 14000, "potential": 24000 }
    }
  },
  "nacto": {
    "id": "nacto",
    "source_title": "Transit Street Design Guide (2016)",
    "source_author": "NACTO",
    "source_url": "https://nacto.org/publication/transit-street-design-guide/introduction/why/designing-move-people/",
    "typical_lane_width": 3,
    "typical_lane_width_ft": 10,
    "segments": {
      "drive-lane": {
        "minimum": 600,
        "potential": 1600,
        "variants": {
          "car-type:pedestrian": {
            "inherits": "sidewalk"
          }
        }
      },
      "bus-lane": { "minimum": 1000, "potential": 2800 },
      "bike-lane": {
        "average": 3750,
        "variants": {
          "bike-direction:twoway-left": {
            "average": 7500
          },
          "bike-direction:twoway-right": {
            "average": 7500
          }
        }
      },
      "scooter": { "inherits": "bike-lane" },
      "brt-lane": { "minimum": 4000, "potential": 8000 },
      "sidewalk": { "average": 9000 },
      "light-rail": { "average": 10000, "potential": 25000 },
      "streetcar": { "inherits": "light-rail" }
    }
  },
  "vancouver": {
    "id": "vancouver",
    "source_title": "People Moving Capacity: Vancouver Urban Transportation Modes (2017)",
    "source_author": "City of Vancouver",
    "source_url": "https://twitter.com/BrentToderian/status/953085021744611328",
    "typical_lane_width": 3,
    "typical_lane_width_ft": 10,
    "segments": {
      "drive-lane": {
        "minimum": 700,
        "average": 850,
        "potential": 1000,
        "variants": {
          "car-type:pedestrian": {
            "inherits": "sidewalk"
          }
        }
      },
      "bus-lane": { "minimum": 1000, "average": 1700, "potential": 2000 },
      "bike-lane": {
        "minimum": 2000,
        "potential": 3000,
        "variants": {
          "bike-direction:twoway-left": {
            "minimum": 4000,
            "potential": 6000
          },
          "bike-direction:twoway-right": {
            "minimum": 4000,
            "potential": 6000
          }
        }
      },
      "scooter": { "inherits": "bike-lane" },
      "brt-lane": { "minimum": 3000, "average": 3500, "potential": 4000 },
      "sidewalk": { "minimum": 5000, "average": 5500, "potential": 6500 },
      "light-rail": { "minimum": 2000, "potential": 2500 },
      "streetcar": { "inherits": "light-rail" }
    }
  }
}
